import {
  BFF_ROUTES,
  EsiidLookupResponseSchema,
  type EsiidLookupRequest,
  type EsiidLookupResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * Typed fetcher for the ESI ID lookup (SHOP-1 / SHOP-3). Thin: build the path,
 * validate against the shared contract schema, return. Pages never import this —
 * the queries layer wraps it.
 *
 * ── PUBLIC POSTURE / AC3 ───────────────────────────────────────────────────
 * Credential-free (`bff-client`): no Authorization, no x-tenant-id. The raw ESI
 * ID is a display/lookup INPUT — the BFF resolves it server-side against the
 * funnel session and returns an OPAQUE `candidateId`; the browser never holds
 * the ESI ID as a redemption key.
 */

/** `POST /bff/esiid/lookup` — raw ESI ID → enriched `MeterDetail` (dummy-data stub today). */
export async function postEsiidLookup(
  request: EsiidLookupRequest,
): Promise<EsiidLookupResponse> {
  return bffPost(BFF_ROUTES.esiidLookup, request, EsiidLookupResponseSchema);
}
